import { Avatar, AvatarSize, theme } from '@ketch-com/deck'
import { TrackerListItemOrigin } from '@ketch-com/windlass/dist/dataSentry/v1/trackers/trackers'
import { Box, Tooltip, Typography } from '@mui/material'
import { useRef } from 'react'
import { useIsOverflow } from '../hooks/useIsOverflow'
import { avatarIconByOrigin, originCopy } from '../constants'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'

export interface MostSeenTrackerItemProps {
  name: string
  percentage: string
  systemName?: string
  systemLogo?: string
  origin: TrackerListItemOrigin
}

export const MostSeenTrackerItem: React.FC<MostSeenTrackerItemProps> = ({
  name,
  percentage,
  systemLogo,
  systemName,
  origin,
}) => {
  const { trackersList, setTrackerOverview } = useDataSentryContext()
  const titleRef = useRef<HTMLDivElement>(null)
  const isTitleOverflow = useIsOverflow({ ref: titleRef })
  const trackersListItem = trackersList?.trackers?.find(tracker => tracker.name === name) || {}
  return (
    <Tooltip title={isTitleOverflow ? name : undefined} placement="top">
      <Box display="flex" flexDirection="column" width="128px" alignItems="center">
        <Avatar
          borderColor={theme.palette.Black.o8}
          icon={avatarIconByOrigin[origin]}
          textColor={theme.palette.Black.o48}
          size={AvatarSize['2xlarge']}
        />
        <Typography
          ref={titleRef}
          mt={1}
          sx={{
            fontSize: '16px',
            fontWeight: '600',
            lineBreak: 'anywhere',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            display: '-webkit-box',
            WebkitLineClamp: '1',
            WebkitBoxOrient: 'vertical',
            cursor: 'pointer',
          }}
          onClick={() => {
            setTrackerOverview(trackersListItem)
          }}
        >
          {name}
        </Typography>
        <Box display="flex" alignItems="center" mt={0.5} gap={0.5}>
          {systemLogo ? (
            <Avatar src={systemLogo} size={AvatarSize.small} />
          ) : (
            <Avatar icon="FUnknown" size={AvatarSize.small} textColor={theme.palette.Black.o48} />
          )}
          <Typography variant="footnote" textAlign="center" color={theme.palette.Text.Primary}>
            {systemName ? systemName : originCopy[origin]}
          </Typography>
        </Box>
        <Typography mt={1}>{percentage}% URLs</Typography>
      </Box>
    </Tooltip>
  )
}
